module.exports = __webpack_public_path__ + "img/编组4.e3b13296.png";